<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="用户"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canDel()"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="用户姓名">
          <el-input
            size="mini"
            v-model="params.Name"
            placeholder="请输入用户姓名"
            clearable
          />
        </el-form-item>
        <el-form-item label="登录账号">
          <el-input
            size="mini"
            v-model="params.LoginId"
            placeholder="请输入登录账号"
            clearable
          />
        </el-form-item>
        <el-form-item label="所属角色">
          <role-select ref="roleSelect" v-model="params.RoleId" />
        </el-form-item>
        <el-form-item label="用户类别" v-if="false">
          <el-select
            size="mini"
            v-model="params.UserType"
            placeholder="请选择用户类别"
            clearable
          >
            <el-option label="平台" :value="0"></el-option>
            <el-option label="商家" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="来源" v-if="false">
          <el-select
            size="mini"
            v-model="params.DataSource"
            placeholder="请选择来源"
            clearable
          >
            <el-option label="小程序申请" :value="1"></el-option>
            <el-option label="后台添加" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            size="mini"
            v-model="params.Status"
            placeholder="请选择状态"
            clearable
          >
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="所属商家"
          prop="StoreId"     v-if="false"   
        >
          <busi-select
            v-model="params.StoreId"
            ref="busiSelect"
          ></busi-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="UserType" label="用户类别" min-width="80px" v-if="false">
          <template slot-scope="{ row }">
            {{ row.UserType == 0 ? "平台" : "商家" }}
          </template>
        </el-table-column>
        <el-table-column prop="StoreName" label="所属商家" min-width="110px" v-if="false"/>
        <el-table-column prop="UserName" label="用户姓名" min-width="110px" />
        <el-table-column prop="LoginId" label="登录账号" min-width="120px">
          <template slot-scope="{ row }">
            <span style="margin-right: 8px">{{ row.LoginId }}</span>
            <el-tag v-if="row.IsLogin == 1" size="mini" type="success"
              >登录中</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="RoleName" label="角色名称" min-width="120px" />
        <el-table-column
          prop="DataSource"
          width="120px"
          label="来源"
          align="center" v-if="false"
        >
          <template slot-scope="{ row }">
            <el-tag size="mini" type="success" v-if="row.DataSource == 1"
              >小程序申请</el-tag
            >
            <el-tag size="mini" type="danger" v-else>后台添加</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="Status" width="80px" label="状态" align="center">
          <template slot-scope="{ row }">
            <el-tag size="mini" type="success" v-if="row.Status == 1"
              >启用</el-tag
            >
            <el-tag size="mini" type="danger" v-else>停用</el-tag>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

import roleSelect from "@/components/sys/role/select";
import busiSelect from "@/components/shop/business/select";

export default {
  mixins: [listMixin],
  components: { list, roleSelect ,busiSelect},
  data() {
    return {
      api: require("@/api/sy/user").default,
      params: {
        Name: "",
        LoginId: "",
        DpName: "",
        IdCard: "",
        RoleId: null,
        Status: null,
        StoreId:null,
      },
    };
  },
  methods: {
    logout(data) {
      console.log("logout", data);
      this.api.forceLogout({ UserId: data.UserId }).then((res) => {
        this.reload();
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>